import { Link } from 'react-router-dom';

export default function AboutHero() {
  return (
    <header className="relative min-h-[68vh] flex items-center justify-center overflow-hidden pt-16">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20forge%20workshop%20with%20glowing%20molten%20metal%20and%20sparks%20flying%20in%20a%20dark%20industrial%20setting%2C%20warm%20amber%20and%20deep%20orange%20tones%20against%20dark%20charcoal%20black%20background%2C%20artistic%20and%20cinematic%2C%20no%20people%2C%20no%20text%2C%20ultra%20wide%20angle%2C%20dramatic%20lighting%2C%20premium%20brand%20aesthetic&width=1920&height=900&seq=about-hero-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/75" />
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 lg:px-8 text-center py-20">
        <span className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-400/30 text-orange-300 text-xs font-bold px-4 py-1.5 rounded-full mb-8 backdrop-blur-sm uppercase tracking-widest">
          Our Story
        </span>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight mb-6">
          Built by Marketers,{' '}
          <span className="text-orange-400">Forged in Fire</span>
        </h1>

        <p className="text-lg text-stone-300 max-w-2xl mx-auto mb-10 leading-relaxed">
          In a world where attention is scarce and competition is relentless, most ads fade into the cold. AdForge was created to change that — combining powerful AI, high-converting copy, and bold visual imagery to craft ads that stand out, endure, and win.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/signup"
            className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Start for Free
          </Link>
          <Link
            to="/features"
            className="px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            Explore Features
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white to-transparent" />
    </header>
  );
}
